module.exports = __webpack_public_path__ + "img/bakong_symbol.fa109db7.png";